/**
 * One lit-in-turn node of a pipeline (the VerdictExplainer idiom,
 * generalised): dims at rest, lights for its window of the cycle, staggered
 * by `at` ticks. Reduced motion: always lit.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC, ReactNode } from 'react';

import { tick } from './use-motion';

export const NODE_CLASS =
  'inline-flex items-center gap-1.5 rounded-md border border-border bg-background px-2 py-1.5 text-xs opacity-55 animate-dg-tut-step motion-reduce:animate-none motion-reduce:opacity-100';

export const Node: FC<{
  /** Which tick of the cycle lights this node. */
  at: number;
  tickSeconds?: number;
  className?: string;
  children: ReactNode;
}> = ({ at, tickSeconds, className, children }) => (
  <span className={`${NODE_CLASS} ${className ?? ''}`} style={tick(at, tickSeconds)}>
    {children}
  </span>
);

/** A row that enters (fades up) at its tick and stays. */
export const Enter: FC<{
  at: number;
  tickSeconds?: number;
  className?: string;
  children: ReactNode;
}> = ({ at, tickSeconds, className, children }) => (
  <div
    className={`animate-dg-tut-enter opacity-0 motion-reduce:animate-none motion-reduce:opacity-100 ${className ?? ''}`}
    style={tick(at, tickSeconds)}
  >
    {children}
  </div>
);
